import React, { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'

import { Backdrop } from '@material-ui/core'

import { useTheme } from '@material-ui/core/styles'

import {
  CloseRounded as CloseIcon,
  RotateLeftRounded as RotateLeftIcon,
  RotateRightRounded as RotateRightIcon,
  ZoomInRounded as ZoomInIcon,
  ZoomOutRounded as ZoomOutIcon,
  ArrowForwardIosRounded as NextIcon,
  ArrowBackIosRounded as BackIcon,
  GetApp as SaveIcon,
} from '@material-ui/icons'

import IconButton from '../../atoms/inputs/iconButton'

import { setGalleryOpen } from '../../../redux/gallery/actions'

import useStyles from './chatPictureStyle'
import handleDownload from '../../../utils/downloadFile'

const ChatPicture = (props) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const galleryOpen = useSelector((state) => state.galleryOpen)
  const activeConversation = useSelector((state) => state.activeConversation)
  const history = useSelector((state) => state.history)
  const messages = useSelector(
    (state) => state.conversations.messages[activeConversation]
  )
  const interactions = useSelector(
    (state) => state.interactions.data?.[activeConversation]
  )

  const ticketGallery = useSelector((state) => state.ticketGallery)
  const tabulationGallery = useSelector((state) => state.tabulationGallery)
  const [zoom, setZoom] = useState(1)
  const [rotate, setRotate] = useState(0)
  const [picture, setPicture] = useState(0)
  const [data, setData] = useState([])

  const refBackDrop = useRef(null)

  let useStylesParams = {
    zoom: zoom,
    rotate: rotate,
  }
  const classes = useStyles(useStylesParams)

  const filterMessages = (listMessage) => {
    let messagesData = null

    if (ticketGallery) {
      messagesData = listMessage
        ?.filter(
          (tickets) =>
            tickets?.file_url && tickets?.mime_type?.split('/')?.[0] === 'image'
        )
        .map((pic) => ({
          picture: pic.file_url,
          pictureName: pic.file_name,
        }))
    } else {
      messagesData = listMessage
        ?.filter(
          (msgs) =>
            msgs.files?.file_url &&
            msgs.files?.mime_type?.split('/')?.[0] === 'image'
        )
        .map((pic) => ({
          picture: pic.files.file_url,
          pictureName: pic.files.file_name,
        }))
    }

    return messagesData
  }

  useEffect(() => {
    if (messages?.length > 0) {
      setData(filterMessages(messages))
    } else {
      setData(filterMessages(history.messages[activeConversation]))
    }
  }, [messages])

  useEffect(() => {
    if (ticketGallery?.ticket?.data) {
      setPicture(ticketGallery?.ticket?.data?.tempIndex)
      setData(filterMessages([...ticketGallery?.ticket?.data?.history]))
    }
  }, [ticketGallery])

  useEffect(() => {
    if (tabulationGallery && activeConversation) {
      setData(tabulationGallery?.galleryTabulation?.data)
    }
  }, [tabulationGallery])

  useEffect(() => {
    if (!galleryOpen?.url) return
    if (!interactions?.length) return

    const aux = interactions
      ?.filter(
        (el) => el?.files && el?.files.mime_type?.split('/')[0] === 'image'
      )
      .map((msg) => {
        return {
          picture: msg?.files?.file_url,
          pictureName: msg?.files?.file_name,
        }
      })

    if (galleryOpen?.url) {
      let i = aux?.find((pic) => pic.picture === galleryOpen?.url)

      let pos = aux?.indexOf(i) !== -1 ? aux?.indexOf(i) : null
      setPicture(pos)
    }

    setData(aux)
  }, [interactions])

  return (
    <>
      <Backdrop
        className={classes.backdrop}
        ref={refBackDrop}
        open={galleryOpen}
      >
        <div className={classes.stage}>
          <img
            className={classes.picture}
            src={data[picture]?.picture}
            style={{
              width: 'auto',
              height: 'auto',
              maxWidth: refBackDrop.current?.offsetWidth,
              maxHeight: refBackDrop.current?.offsetHeight,
            }}
            alt=""
          />
        </div>
        <div className={classes.body}>
          <div className={classes.header}>
            <div>
              <div style={{ width: 48 }} />
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <IconButton
                color="primary"
                onClick={() => {
                  zoom < 1.5 && setZoom(zoom + 0.25)
                }}
              >
                <ZoomInIcon />
              </IconButton>
              <div style={{ width: 15 }} />
              <IconButton
                color="primary"
                onClick={() => {
                  zoom > 1 && setZoom(zoom - 0.25)
                }}
              >
                <ZoomOutIcon />
              </IconButton>
              <div style={{ width: 15 }} />
              <IconButton
                color="primary"
                onClick={() => setRotate(rotate - 90)}
              >
                <RotateLeftIcon />
              </IconButton>
              <div style={{ width: 15 }} />
              <IconButton
                color="primary"
                onClick={() => setRotate(rotate + 90)}
              >
                <RotateRightIcon />
              </IconButton>
              <div style={{ width: 15 }} />
              <IconButton color="primary">
                <SaveIcon
                  color="primary"
                  onClick={() =>
                    handleDownload(
                      data[picture].picture,
                      data[picture].pictureName
                    )
                  }
                />
              </IconButton>
              {/* <div style={{ width: 15 }} />
              <IconButton color="primary">
                <ReplyIcon style={{ transform: 'scaleX(-1)' }} />
              </IconButton> */}
            </div>
            <div>
              <IconButton
                color="primary"
                onClick={() => dispatch(setGalleryOpen(false))}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </div>
          <div className={classes.content}>
            <IconButton
              color="primary"
              onClick={() => {
                picture > 0
                  ? setPicture(picture - 1)
                  : setPicture(data.length - 1)
              }}
            >
              <BackIcon />
            </IconButton>
            <IconButton
              color="primary"
              onClick={() => {
                picture < data.length - 1
                  ? setPicture(picture + 1)
                  : setPicture(0)
              }}
            >
              <NextIcon />
            </IconButton>
          </div>
          <div className={classes.footer}>
            {data.length > 0 &&
              data.map((el, index) => {
                return (
                  <div
                    className={
                      picture === index
                        ? classes.thumbnailActive
                        : classes.thumbnail
                    }
                    style={{
                      backgroundImage: `url(${el.picture})`,
                      backgroundSize: 'cover',
                    }}
                    onClick={() => {
                      setPicture(index)
                    }}
                  ></div>
                )
              })}
          </div>
        </div>
      </Backdrop>
    </>
  )
}

export default ChatPicture
